import { Box, Typography, Alert } from "@mui/material"
import React from "react"
import { Warning } from "@mui/icons-material"

const NotFound = () => {
  return (
    <Box textAlign='center' mt={1} p={2} width='100%'>
      <Alert icon={<Warning />} severity='warning'>
        <Typography variant='body1'>اطلاعاتی یافت نشد!</Typography>
      </Alert>
    </Box>
  )
}

export default NotFound
